import axios from "axios";

// redirects the browser to the login page when there is an authentication error
function intercept401Errors() {
    axios.interceptors.response.use((response) => {
        // Check if session has timed-out (detect the login page in the response).

        // NOTE: this only handles get & delete requests.  For post/put requests, users  probably 
        // won't want to lose their work. These should be handled more elegantly (e.g. Snotify)

        if ((response.config.method === "get" || response.config.method === "delete") && response.request.responseURL
            && response.request.responseURL.toLowerCase().includes("/authentication/login")) {

            //take the user back to the login page
            window.location = "/core";
        }
        return response;
    });
}

export default { intercept401Errors };